module.exports = __webpack_public_path__ + "assets/pdf/E04-en-beijing-haze.118638ba.pdf";